import React from "react";
import styles from "../../../../styles/pages/user/managerdashboard/manager-dashboard-support.module.scss";
import ManagerDashboardWapper from "../../../../layout/wrapper/ManagerDashboardWapper";
import {
  Box,
  List,
  ListItem,
  Select,
  MenuItem,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
  Dialog,
  Grid,
  TextField,
  Stack,
  Popover,
} from "@mui/material";
import HeadphoneIcon from "../../../../public/assets/icons/HeadphoneIcon";
import CrossIcon from "../../../../ui/Icons/CrossIcon";
import UploadPin from "../../../../ui/Icons/UploadPin";
import { useNavigate } from "react-router";
import key_icon from "../../../../public/assets/images/lock_icon.svg";
import "react-perfect-scrollbar/dist/css/styles.css";
import PerfectScrollbar from "react-perfect-scrollbar";
import { Link } from "react-router-dom";
import view_icon from "../../../../public/assets/images/eye_icon.svg";
import LeftArrow from "../../../../ui/Icons/LeftArrow";
import RightArrow from "../../../../ui/Icons/RightArrow";
import CalenderIcon from "../../../../ui/Icons/CalenderIcon";
import PrevIcon from "../../../../ui/Icons/PrevIcon";
import NextIcon from "../../../../ui/Icons/NextIcon";
import AddPlusIcon from "../../../../public/assets/icons/AddPlusIcon";
import BtnCrossIcon from "../../../../public/assets/icons/BtnCrossIcon";
import TrashIcon from "../../../../public/assets/icons/TrashIcon";
import useFetch from "../../../../hooks/api/useFetch";
import {
  getMonthQueryRange,
  getMonthRange,
  getPagination,
  getStyledDateTime,
  getUtcDate,
  getUtcTime,
  getYearRange,
} from "../../../../lib/functions/utils.lib";
import ApiLoader from "../../../../components/Loaders/ApiLoader";
import { parseCookies } from "nookies";
import axiosInstance from "../../../../api/axiosInstance";

const TicketSelectItem = [
  {
    name: "Option1",
  },
  {
    name: "Option2",
  },
];

export default function Support() {
  const [status, setStatus] = React.useState("");
  const [month, setMonth] = React.useState("");
  const [year, setYear] = React.useState("");
  const [page, setPage] = React.useState(1);
  const [archive, setArchive] = React.useState(false);

  const cookies = parseCookies();
  const userData = JSON.parse(cookies?.userdetails || "{}");

  const {
    data: messages,
    isLoading,
    isSuccess,
    isError,
    refetch,
  } = useFetch(
    ["messages-support", status, archive, month, year],
    `inquiries?type=support${
      status.toString()
        ? `&${status == 2 ? "need_your_reply=yes" : "status=" + status}`
        : ""
    }
        &archive=${archive ? 1 : 0}
        ${month && year ? getMonthQueryRange(month, year) : ""}`
  );

  const [attachments, setAttachments] = React.useState([]);

  const handleFileChange = (event) => {
    const file = event.target.files?.[0];
    if (file) {
      setAttachments((curr) => [...curr, file]);
    }
  };

  const removeFile = (file_index) => {
    setAttachments((curr) => curr.filter((_, index) => file_index !== index));
  };

  const [newTicketFormData, setNewTicketFormData] = React.useState({
    subject: "",
    message: "",
  });

  const handleNewTicketFormData = (event) => {
    const { name, value } = event.target;
    setNewTicketFormData((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const submitNewTicket = async () => {
    const formData = new FormData();
    formData.append("subject", newTicketFormData.subject);
    formData.append("message", newTicketFormData.message);
    formData.append("user_id", userData.id);
    formData.append("to_user_id", 1);
    formData.append("receiver_role", 1);
    formData.append("priority", age2);
    await axiosInstance
      .post("/inquiry-create", formData)
      .then((res) => {
        console.warn(res);
        refetch();
        setOpen(false);
        ticketSuccessdUpdate(true);
        setTimeout(() => ticketSuccessdUpdate(false), 1000);
      })
      .catch((err) => console.error(err));
  };

  const [paginationData, setPaginationData] = React.useState({
    hasNextPage: false,
    hasPrevPage: false,
  });

  const handleNextPage = () => {
    if (paginationData.hasNextPage) setPage((prev) => prev + 1);
  };
  const handlePrevPage = () => {
    if (paginationData.hasPrevPage) setPage((prev) => prev - 1);
  };

  const handleArchiveToggle = () => {
    setArchive((prev) => !prev);
  };

  const handleChangeStatus = (event) => {
    setStatus(event.target.value);
  };

  const handleChangeMonth = (event) => {
    setMonth(event.target.value);
  };

  const handleChangeYear = (event) => {
    setYear(event.target.value);
  };

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const open1 = Boolean(anchorEl);
  const id = open1 ? "simple-popover" : undefined;

  const [age2, setAge2] = React.useState();
  const handleChange3 = (event) => {
    setAge2(event.target.value);
  };

  const [Archive, ArchiveUpdate] = React.useState(false);
  const handleClicked = () => {
    ArchiveUpdate(!Archive);
  };

  const [open, setOpen] = React.useState(false);
  const ticketClickOpen = () => {
    setOpen(true);
  };

  const ticketClose = (value) => {
    setOpen(false);
  };

  const [open3, setOpen3] = React.useState(false);
  const ticketClickOpen3 = () => {
    setOpen3(true);
  };

  const ticketClose3 = (value) => {
    setOpen3(false);
  };

  const [ticketSuccess, ticketSuccessdUpdate] = React.useState(false);
  const navigate = useNavigate();

  const ticketCreated = (e) => {
    setOpen(false);
    ticketSuccessdUpdate(true);
    // setTimeout(() => {
    //     navigate('/editor-dashboard/editor-support/tickets');
    // }, "2000");
  };
  const getStatus = (inquiry) => {
    if (!inquiry?.status) {
      if (inquiry?.initiated?.name === inquiry?.last_message?.sender?.name)
        return {
          name: "Need your reply",
          class: `${styles.noNeed} ${styles.statusTxt}`,
        };
      return {
        name: "Pending",
        class: `${styles.pending} ${styles.statusTxt}`,
      };
    }
    return {
      name: "Resolved",
      class: `${styles.removed} ${styles.statusTxt}`,
    };
  };
  React.useEffect(() => {
    const { hasNextPage, hasPrevPage } = getPagination(
      messages?.data?.meta?.currentPage,
      messages?.data?.meta?.lastPage
    );
    setPaginationData({ hasNextPage: hasNextPage, hasPrevPage: hasPrevPage });
  }, [messages]);
  return (
    <>
      <ManagerDashboardWapper>
        <ApiLoader
          loading={
            isLoading &&
            !(messages?.data.data.length || status.toString() || month || year)
          }
        />
        {isLoading &&
        !(messages?.data.data.length || status.toString() || month || year) ? (
          ""
        ) : (isSuccess && messages?.data.data.length) ||
          status.toString() ||
          month ||
          year ? (
          <>
            {ticketSuccess ? (
              <Box className={styles.ticket_creation_wrapper}>
                <Typography
                  variant="caption"
                  className={styles.ticket_create_span}
                >
                  Ticket Created Successfully
                </Typography>
              </Box>
            ) : (
              ""
            )}
            <Box className={styles.message_status_wrapper}>
              <Box className={styles.message_status_topwrp}>
                <Stack
                  direction="row"
                  alignItems="center"
                  flexWrap="wrap"
                  className={styles.messageHeader}
                >
                  <Select
                    value={status}
                    onChange={handleChangeStatus}
                    displayEmpty
                    inputProps={{ "aria-label": "Without label" }}
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          boxShadow: "0px 0px 4px 1px rgba(0, 0, 0, 0.08)",
                          borderRadius: "7px",
                          marginTop: "5px",

                          "& .MuiMenuItem-root": {
                            padding: 0,
                            fontSize: "11px",
                            fontWeight: "500",
                            color: "#525050",
                            lineHeight: "1",
                            "&:hover": {
                              backgroundColor: "#ffffff",
                              color: "#111ae9",
                            },
                            "&:not(:last-child)": {
                              marginBottom: "10px",
                            },
                            "&:first-child": {
                              display: "none",
                            },
                          },
                          "& .Mui-selected": {
                            background: "#fff !important",
                          },

                          "& .MuiList-root": {
                            padding: "20px 14px",
                            minWidth: "134px",
                          },
                        },
                      },
                    }}
                  >
                    <MenuItem value="">Ticket Status</MenuItem>
                    <MenuItem value={2}>Need your reply</MenuItem>
                    <MenuItem value={0}>Pending</MenuItem>
                    <MenuItem value={1}>Resolved</MenuItem>
                  </Select>
                  <Box className={styles.creationDate}>
                    <Button
                      aria-describedby={id}
                      variant="contained"
                      onClick={handleClick}
                      endIcon={<CalenderIcon />}
                    >
                      Creation Date
                    </Button>
                    <Popover
                      id={id}
                      open={open1}
                      anchorEl={anchorEl}
                      onClose={handleClose}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "left",
                      }}
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "left",
                      }}
                      PaperProps={{
                        sx: {
                          boxShadow: "0px 0px 4px 1px rgba(0, 0, 0, 0.08)",
                          borderRadius: "7px",
                          marginTop: "5px",
                          padding: "24px",
                          maxWidth: "254px",
                          width: "100%",
                          "& .MuiTypography-caption": {
                            fontWeight: "500",
                            fontSize: "13px",
                            color: "#494949",
                            marginBottom: "8px",
                            display: "block",
                          },
                        },
                      }}
                    >
                      <Typography variant="caption">Created in</Typography>
                      <Stack
                        direction="row"
                        alignItems="center"
                        flexWrap="wrap"
                        className={styles.selectDate}
                      >
                        <Select
                          value={month}
                          onChange={handleChangeMonth}
                          displayEmpty
                          inputProps={{
                            "aria-label": "Without label",
                          }}
                          MenuProps={{
                            PaperProps: {
                              sx: {
                                boxShadow:
                                  "0px 0px 4px 1px rgba(0, 0, 0, 0.08)",
                                borderRadius: "7px",
                                marginTop: "5px",

                                "& .MuiMenuItem-root": {
                                  padding: 0,
                                  fontSize: "11px",
                                  fontWeight: "500",
                                  color: "#525050",
                                  lineHeight: "1",
                                  "&:hover": {
                                    backgroundColor: "#ffffff",
                                    color: "#111ae9",
                                  },
                                  "&:not(:last-child)": {
                                    marginBottom: "10px",
                                  },
                                  "&:first-child": {
                                    display: "none",
                                  },
                                },
                                "& .Mui-selected": {
                                  background: "#fff !important",
                                },

                                "& .MuiList-root": {
                                  padding: "20px 14px",
                                },
                              },
                            },
                          }}
                        >
                          <MenuItem value="">Month</MenuItem>
                          {getMonthRange().map((item, index) => (
                            <MenuItem value={item?.value} key={index}>
                              {item?.month}
                            </MenuItem>
                          ))}
                        </Select>
                        <Select
                          value={year}
                          onChange={handleChangeYear}
                          displayEmpty
                          inputProps={{
                            "aria-label": "Without label",
                          }}
                          MenuProps={{
                            PaperProps: {
                              sx: {
                                boxShadow:
                                  "0px 0px 4px 1px rgba(0, 0, 0, 0.08)",
                                borderRadius: "7px",
                                marginTop: "5px",

                                "& .MuiMenuItem-root": {
                                  padding: 0,
                                  fontSize: "11px",
                                  fontWeight: "500",
                                  color: "#525050",
                                  lineHeight: "1",
                                  "&:hover": {
                                    backgroundColor: "#ffffff",
                                    color: "#111ae9",
                                  },
                                  "&:not(:last-child)": {
                                    marginBottom: "10px",
                                  },
                                  "&:first-child": {
                                    display: "none",
                                  },
                                },
                                "& .Mui-selected": {
                                  background: "#fff !important",
                                },

                                "& .MuiList-root": {
                                  padding: "20px 14px",
                                },
                              },
                            },
                          }}
                        >
                          <MenuItem value="">Year</MenuItem>
                          {getYearRange().map((item, index) => (
                            <MenuItem value={item.value} key={index}>
                              {item.year}
                            </MenuItem>
                          ))}
                        </Select>
                      </Stack>
                    </Popover>
                  </Box>
                  <Button
                    className={
                      archive
                        ? `${styles.archievr_btns} ${styles.active}`
                        : `${styles.archievr_btns}`
                    }
                    onClick={handleArchiveToggle}
                  >
                    Archive
                  </Button>
                </Stack>

                <Box className={styles.message_status_topwrp_rtt}>
                  <Button
                    className={styles.ticket_btn_black}
                    onClick={ticketClickOpen}
                  >
                    New Ticket
                  </Button>
                </Box>
              </Box>

              <Box className={styles.message_status_btmwrp}>
                <TableContainer>
                  <Table
                    aria-label="customized table"
                    className={`${styles.new_table_customised} ${
                      archive ? styles.archiveTableSec : ""
                    }`}
                    stickyHeader
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell component="th" className={styles.thTicketId}>
                          Ticket ID
                        </TableCell>
                        {!archive ? (
                          <TableCell
                            component="th"
                            className={styles.thPriority}
                          >
                            Priority
                          </TableCell>
                        ) : (
                          ""
                        )}
                        <TableCell component="th" className={styles.thSubject}>
                          Subject
                        </TableCell>
                        <TableCell component="th" className={styles.thMessage}>
                          Message
                        </TableCell>
                        <TableCell
                          component="th"
                          className={styles.thCreationDate}
                        >
                          Creation Date
                        </TableCell>
                        <TableCell
                          component="th"
                          className={styles.thTicketResolve}
                        >
                          {!archive ? "Ticket Status" : "Resolved On"}
                        </TableCell>
                        <TableCell component="th" className={styles.thView}>
                          View
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {messages?.data?.data.map((row, index) => {
                        if (
                          status === 0 &&
                          row?.initiated?.name ===
                            row?.last_message?.sender?.name
                        )
                          return "";
                        else if (
                          status === 2 &&
                          row?.initiated?.name !==
                            row?.last_message?.sender?.name
                        )
                          return "";
                        else if (status === 2 && row?.status) return "";
                        return (
                          <TableRow key={index}>
                            <TableCell
                              component="td"
                              scope="row"
                              className={`${styles.ticket_id_table} ${styles.thTicketId}`}
                            >
                              <Box className={styles.table_id_captns}>
                                <Link to="/">{row?.id ? row?.id : "-"}</Link>

                                <Typography
                                  variant="caption"
                                  className={styles.tooltips_spn}
                                >
                                  Open Video Page
                                </Typography>
                              </Box>
                            </TableCell>
                            {!archive ? (
                              <TableCell
                                component="td"
                                scope="row"
                                className={`${styles.proiority_table} ${styles.thPriority}`}
                              >
                                <Typography
                                  variant="caption"
                                  className={
                                    row?.priority === 1
                                      ? `${styles.low_priority} ${styles.cmn_structure_prority}`
                                      : row?.priority === 3
                                      ? `${styles.high_priority} ${styles.cmn_structure_prority}`
                                      : row?.priority === 4
                                      ? `${styles.crtical_priority} ${styles.cmn_structure_prority}`
                                      : `${styles.medium_priority} ${styles.cmn_structure_prority}`
                                  }
                                >
                                  {row?.priority === 1
                                    ? "Low"
                                    : row?.priority === 3
                                    ? "High"
                                    : row?.priority === 4
                                    ? "Critical"
                                    : "Medium"}
                                </Typography>
                              </TableCell>
                            ) : (
                              ""
                            )}

                            <TableCell
                              component="td"
                              scope="row"
                              className={`${styles.subject_table} ${styles.thSubject}`}
                            >
                              <Typography variant="body2">
                                {row?.subject ? row?.subject : "-"}
                              </Typography>
                            </TableCell>

                            <TableCell
                              component="td"
                              scope="row"
                              className={`${styles.messages_table} ${styles.thMessage}`}
                            >
                              <Typography variant="body2">
                                {row?.message
                                  ? row?.message?.length > 20
                                    ? row.message.slice(0, 17) + "..."
                                    : row.message
                                  : "_"}
                              </Typography>
                            </TableCell>

                            <TableCell
                              component="td"
                              scope="row"
                              className={`${styles.creation_date_table} ${styles.thCreationDate}`}
                            >
                              {/* {row?.created ? getStyledDateTime(row?.created) : "-"} */}
                              <Typography variant="body2">
                                {row?.created ? (
                                  <>
                                    {getUtcDate(row?.created)} <br />{" "}
                                    {getUtcTime(row?.created)}
                                  </>
                                ) : (
                                  "-"
                                )}
                              </Typography>
                            </TableCell>

                            {archive ? (
                              <TableCell
                                component="td"
                                scope="row"
                                className={`${styles.resolve_table_date} ${styles.thTicketResolve}`}
                              >
                                {/* {row?.resolved_at
                                    ? getStyledDateTime(row?.resolved_at)
                                    : "-"} */}
                                <Typography variant="body2">
                                  {row?.resolved_at ? (
                                    <>
                                      {getUtcDate(row?.resolved_at)} <br />{" "}
                                      {getUtcTime(row?.resolved_at)}
                                    </>
                                  ) : (
                                    "-"
                                  )}
                                </Typography>
                              </TableCell>
                            ) : (
                              ""
                            )}
                            {!archive ? (
                              <TableCell
                                component="td"
                                scope="row"
                                className={`${styles.status_table} ${
                                  styles.thTicketResolve
                                } ${getStatus(row)?.class}`}
                              >
                                <Typography
                                  variant="caption"
                                  className={`${styles.quer_sec_btns} ${styles.resolved}`}
                                >
                                  {getStatus(row)?.name}
                                </Typography>
                              </TableCell>
                            ) : (
                              ""
                            )}

                            <TableCell
                              component="td"
                              scope="row"
                              className={`${styles.view_sec_table} ${styles.thView}`}
                            >
                              <Link
                                className={styles.eye_icon_sec}
                                to={`/manager-dashboard/message-details/${row?.id}`}
                              >
                                <img src={view_icon} alt="" />
                              </Link>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>

                {/*                   <PerfectScrollbar>
                    <TableContainer>
                      <Table aria-label="customized table">
                        <TableHead>
                          <TableRow>
                            {tableHead.map((item, index) => (
                              <TableCell component="th">{item?.name}</TableCell>
                            ))}
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {tableBody.map((item, index) => (
                            <TableRow>
                              <TableCell
                                component="td"
                                scope="row"
                                className={styles.ticket_id_table}
                              >
                                <Box className={styles.table_id_captns}>
                                  <Link to="/">{item?.id}</Link>

                                  <Typography
                                    variant="caption"
                                    className={styles.tooltips_spn}
                                  >
                                    Open Video Page
                                  </Typography>
                                </Box>
                              </TableCell>

                              <TableCell
                                component="td"
                                scope="row"
                                className={styles.proiority_table}
                              >
                                <Typography
                                  variant="caption"
                                  className={
                                    item?.priority === "low"
                                      ? `${styles.low_priority} ${styles.cmn_structure_prority}`
                                      : item?.priority === "high"
                                      ? `${styles.high_priority} ${styles.cmn_structure_prority}`
                                      : item?.priority === "critical"
                                      ? `${styles.crtical_priority} ${styles.cmn_structure_prority}`
                                      : `${styles.medium_priority} ${styles.cmn_structure_prority}`
                                  }
                                >
                                  {item?.priority === "low"
                                    ? "Low"
                                    : item?.priority === "high"
                                    ? "High"
                                    : item?.priority === "critical"
                                    ? "Critical"
                                    : "Medium"}
                                </Typography>
                              </TableCell>

                              <TableCell
                                component="td"
                                scope="row"
                                className={styles.subject_table}
                              >
                                {item?.subject}
                              </TableCell>

                              <TableCell
                                component="td"
                                scope="row"
                                className={styles.messages_table}
                              >
                                {item?.message}
                              </TableCell>

                              <TableCell
                                component="td"
                                scope="row"
                                className={styles.creation_date_table}
                              >
                                {item?.date}
                              </TableCell>

                              <TableCell
                                component="td"
                                scope="row"
                                className={styles.status_table}
                              >
                                {item?.statusQuery ? (
                                  <Typography
                                    variant="caption"
                                    className={`${styles.quer_sec_btns} ${styles.resolved}`}
                                  >
                                    Resolved
                                  </Typography>
                                ) : (
                                  <Button className={styles.quer_sec_btns}>
                                    Need your reply
                                  </Button>
                                )}
                              </TableCell>

                              <TableCell
                                component="td"
                                scope="row"
                                className={styles.view_sec_table}
                              >
                                <Button className={styles.eye_icon_sec}>
                                  <img src={view_icon} alt="" />
                                </Button>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </PerfectScrollbar> */}
              </Box>

              <Stack
                direction="row"
                flexWrap="wrap"
                alignItems="center"
                className="btnPagination"
              >
                <Button startIcon={<PrevIcon />}>Prev</Button>
                <Button endIcon={<NextIcon />}>Next</Button>
              </Stack>
            </Box>
          </>
        ) : (
          <Box className={styles.emptyMsg}>
            <HeadphoneIcon />
            <Typography variant="body1">
              You don't have any support tickets at the moment.
            </Typography>
            <Button
              className={styles.ticket_collect_btns}
              onClick={ticketClickOpen}
            >
              New Ticket
            </Button>
          </Box>
        )}
      </ManagerDashboardWapper>

      <Dialog
        onClose={ticketClose}
        open={open}
        className={styles.dialog_coupon_modals}
      >
        <Box className={styles.ticket_support_modal}>
          <Box className={styles.ticket_support_modal_top}>
            <Typography variant="caption" className={styles.ticket_coupn_sec}>
              Create a new support ticket
            </Typography>

            <Typography variant="caption" className={styles.ticket_id_sec}>
              <strong>Ticket ID:</strong> #SR5264
            </Typography>
            <Button className={styles.cross_icons} onClick={ticketClose}>
              <CrossIcon />
            </Button>
          </Box>

          <Box className={styles.ticket_support_modal_btms}>
            <Grid
              container
              spacing={2}
              className={styles.ticket_support_modal_btms_row}
            >
              <Grid item lg={4.791} xs={12}>
                <Box className={styles.ticket_form_modal}>
                  <Typography variant="h5" className={styles.modal_h5}>
                    Priority
                  </Typography>
                  <Box
                    className={`${styles.status_messages_inputfrm} ${styles.selectbox}`}
                  >
                    <Select
                      onChange={handleChange3}
                      value={age2}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            boxShadow: "0px 0px 4px 1px rgba(0, 0, 0, 0.08)",
                            borderRadius: "7px",
                            marginTop: "5px",

                            "& .MuiMenuItem-root": {
                              padding: 0,
                              fontSize: "11px",
                              fontWeight: "500",
                              color: "#525050",
                              lineHeight: "1",
                              "&:hover": {
                                backgroundColor: "#ffffff",
                                color: "#111ae9",
                              },
                              "&:not(:last-child)": {
                                marginBottom: "10px",
                              },
                            },
                            "& .Mui-selected": {
                              background: "#fff !important",
                            },

                            "& .MuiList-root": {
                              padding: "20px 14px",
                              minWidth: "134px",
                            },
                          },
                        },
                      }}
                    >
                      <MenuItem value={1}>Low</MenuItem>
                      <MenuItem value={2}>Medium</MenuItem>
                      <MenuItem value={3}>High</MenuItem>
                      <MenuItem value={4}>Critical</MenuItem>
                    </Select>
                  </Box>
                </Box>
              </Grid>

              <Grid item lg={12} xs={12}>
                <Box className={styles.ticket_form_modal}>
                  <Typography variant="h5" className={styles.modal_h5}>
                    Subject
                  </Typography>
                  <Box className={styles.status_messages_inputfrm}>
                    <TextField
                      name="subject"
                      onChange={handleNewTicketFormData}
                    />
                  </Box>
                </Box>
              </Grid>

              <Grid item lg={12} xs={12}>
                <Box className={styles.ticket_form_modal}>
                  <Typography variant="h5" className={styles.modal_h5}>
                    How can we help you?
                  </Typography>
                  <Box
                    className={`${styles.status_messages_inputfrm} ${styles.textareas}`}
                  >
                    <TextField
                      multiline
                      name="message"
                      onChange={handleNewTicketFormData}
                    />
                  </Box>
                </Box>
              </Grid>

              <Grid item lg={12} xs={12}>
                <Box className={styles.ticket_form_modal}>
                  <Box className={styles.attach_frm_messages}>
                    <Box className={styles.input_boxfile_attach}>
                      <Box className={styles.input_boxfile_outer}>
                        <Typography variant="caption">
                          <i>
                            <UploadPin />
                          </i>{" "}
                          Attach a file
                        </Typography>
                      </Box>
                      <TextField
                        onChange={handleFileChange}
                        type="file"
                        className={styles.file_uploaders}
                      />
                    </Box>
                  </Box>
                  {attachments?.length
                    ? attachments.map((item, index) => (
                        <Box key={index} className={styles.attach_frm_messages}>
                          <Stack
                            direction={"row"}
                            alignItems={"center"}
                            className={styles.showAddFile}
                          >
                            <Button onClick={() => removeFile(index)}>
                              <TrashIcon />
                            </Button>
                            <span>{item?.name ? item.name : "N/A"}</span>
                          </Stack>
                        </Box>
                      ))
                    : ""}
                  {/* <Box className={styles.attach_frm_messages}>
                    <Stack
                      direction={"row"}
                      alignItems={"center"}
                      className={styles.showAddFile}
                    >
                      <Button>
                        <TrashIcon />
                      </Button>
                      <span>
                        325007798_724967765618154_1330143271608700845_n.png
                      </span>
                    </Stack>
                    <Button className={styles.btnAddBlack}>
                      <AddPlusIcon />
                    </Button>
                  </Box> */}
                  {attachments?.length ? (
                    <Box className={styles.attach_frm_messages}>
                      <Box className={styles.input_boxfile_attach}>
                        <Box
                          className={`${styles.input_boxfile_outer} ${styles.input_selectFile}`}
                        >
                          <Typography variant="caption">
                            <i>
                              <UploadPin />
                            </i>{" "}
                            Select file
                          </Typography>
                        </Box>
                        <TextField
                          onChange={handleFileChange}
                          type="file"
                          className={styles.file_uploaders}
                        />
                      </Box>
                      <Button
                        className={`${styles.btnAddBlack} ${styles.roundBtn}`}
                      >
                        <BtnCrossIcon />
                      </Button>
                    </Box>
                  ) : (
                    ""
                  )}
                </Box>
              </Grid>

              <Grid item lg={12} xs={12} className={styles.submit_sec_btms}>
                <Box className={styles.submit_sec_btns_foot}>
                  <Button
                    className={styles.cancel_btn_modal}
                    onClick={ticketClose}
                  >
                    Cancel
                  </Button>
                  <Button
                    className={styles.send_btn_modal}
                    onClick={submitNewTicket}
                  >
                    Send <Typography variant="caption">now</Typography>
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Dialog>

      {/* For no message modal  */}
      {/* 
      <Dialog
        onClose={ticketClose3}
        open={open3}
        className={styles.dialog_coupon_modals}
      >
        <Box className={styles.ticket_support_modal}>
          <Box className={styles.ticket_support_modal_top}>
            <Typography variant="caption" className={styles.ticket_coupn_sec}>
              Create a new support ticket
            </Typography>

            <Typography variant="caption" className={styles.ticket_id_sec}>
              <strong>Ticket ID:</strong> #SR5264
            </Typography>
            <Button className={styles.cross_icons} onClick={ticketClose3}>
              <CrossIcon />
            </Button>
          </Box>

          <Box className={styles.ticket_support_modal_btms}>
            <Grid
              container
              rowSpacing={2}
              className={styles.ticket_support_modal_btms_row}
            >
              <Grid item lg={4.791} xs={12}>
                <Box className={styles.ticket_form_modal}>
                  <Typography variant="h5" className={styles.modal_h5}>
                    Priority
                  </Typography>
                  <Box
                    className={`${styles.status_messages_inputfrm} ${styles.selectbox}`}
                  >
                    <Select
                      onChange={handleChange3}
                      value={age2}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            boxShadow: "0px 0px 4px 1px rgba(0, 0, 0, 0.08)",
                            borderRadius: "7px",
                            marginTop: "5px",

                            "& .MuiMenuItem-root": {
                              padding: 0,
                              fontSize: "11px",
                              fontWeight: "500",
                              color: "#525050",
                              lineHeight: "1",
                              "&:hover": {
                                backgroundColor: "#ffffff",
                                color: "#111ae9",
                              },
                              "&:not(:last-child)": {
                                marginBottom: "10px",
                              },
                            },
                            "& .Mui-selected": {
                              background: "#fff !important",
                            },

                            "& .MuiList-root": {
                              padding: "20px 14px",
                              minWidth: "134px",
                            },
                          },
                        },
                      }}
                    >
                      {TicketSelectItem.map((item, index) => (
                        <MenuItem value={index}>{item?.name}</MenuItem>
                      ))}
                    </Select>
                  </Box>
                </Box>
              </Grid>

              <Grid item lg={12} xs={12}>
                <Box className={styles.ticket_form_modal}>
                  <Typography variant="h5" className={styles.modal_h5}>
                    Subject
                  </Typography>
                  <Box className={styles.status_messages_inputfrm}>
                    <TextField />
                  </Box>
                </Box>
              </Grid>

              <Grid item lg={12} xs={12}>
                <Box className={styles.ticket_form_modal}>
                  <Typography variant="h5" className={styles.modal_h5}>
                    How can we help you?
                  </Typography>
                  <Box
                    className={`${styles.status_messages_inputfrm} ${styles.textareas}`}
                  >
                    <TextField multiline />
                  </Box>
                </Box>
              </Grid>

              <Grid item lg={12} xs={12}>
                <Box className={styles.ticket_form_modal}>
                  <Box className={styles.attach_frm_messages}>
                    <Box className={styles.input_boxfile_attach}>
                      <Box className={styles.input_boxfile_outer}>
                        <Typography variant="caption">
                          <i>
                            <UploadPin />
                          </i>{" "}
                          Attach a file
                        </Typography>
                      </Box>
                      <TextField
                        type="file"
                        className={styles.file_uploaders}
                      />
                    </Box>
                  </Box>
                </Box>
              </Grid>

              <Grid item lg={12} xs={12} className={styles.submit_sec_btms}>
                <Box className={styles.submit_sec_btns_foot}>
                  <Button
                    className={styles.cancel_btn_modal}
                    onClick={ticketClose3}
                  >
                    Cancel
                  </Button>
                  <Button
                    className={styles.send_btn_modal}
                    onClick={ticketClose3}
                  >
                    Send <Typography variant="caption">now</Typography>
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Dialog> */}
    </>
  );
}
